module.exports = __webpack_public_path__ + "img/thumbnail_BlackWildebeest_m_normal.deac8e24.png";